import {
    ProductFormProductIngredient,
    ProductFormProductTransport,
} from "src/pages/Product/ProductForm/ProductForm.types";
import { getProductIngredientTransportKey } from "./productIngredientTransportKey";

export type PersistedDraftProductTransportsResult = {
    persistedTransports: ProductFormProductTransport[];
    unmatchedTransports: ProductFormProductTransport[];
};

export const mergeResolvedDraftProductTransports = (
    existingTransports: ProductFormProductTransport[] | undefined,
    resolution: PersistedDraftProductTransportsResult,
): ProductFormProductTransport[] => [
    ...(existingTransports ?? []),
    ...resolution.persistedTransports,
    ...resolution.unmatchedTransports,
];

export const buildPersistedDraftProductTransports = (
    draftProductTransports: ProductFormProductTransport[],
    persistedIngredients: ProductFormProductIngredient[],
): PersistedDraftProductTransportsResult => {
    const result: PersistedDraftProductTransportsResult = {
        persistedTransports: [],
        unmatchedTransports: [],
    };

    draftProductTransports.forEach((transport) => {
        const draftKey = transport.draftProductIngredientKey;
        if (draftKey == null) {
            result.unmatchedTransports.push(transport);
            return;
        }

        const persistedIngredient = persistedIngredients.find(
            (ingredient) => getProductIngredientTransportKey(ingredient) === draftKey,
        );
        if (persistedIngredient?.["@id"] === undefined || persistedIngredient.id === undefined) {
            result.unmatchedTransports.push(transport);
            return;
        }

        result.persistedTransports.push({
            ...transport,
            productIngredient: {
                "@id": persistedIngredient["@id"],
                id: persistedIngredient.id,
            },
            draftProductIngredientKey: null,
        });
    });

    return result;
};
